import { ValidateFnType } from '../models/ValidateFnType'

export const validateRequired: ValidateFnType = (t) => ({
  required: {
    value: true,
    message: t('validate.isRequiredError'),
  },
})
